// extracted by mini-css-extract-plugin
module.exports = {"modelImage":"modelImage_modelImage__dw_2L"};